import z from "zod";
import { QuestionStrategySchema, SourceDocSchema, } from "../question-types-and-schema.js";
export const wizardConfigurationSchema = z.object({
    language: z.string().nullable().optional().default(null),
    navigationType: z
        .enum(["progress", "index"])
        .nullable()
        .optional()
        .default(null),
    questionStrategy: QuestionStrategySchema,
    sourceDoc: SourceDocSchema,
    requestInitialAnswers: z
        .enum(["true", "false"])
        .optional()
        .default("false")
        .transform(val => val === "true"),
    showCardImage: z
        .enum(["true", "false"])
        .default("true")
        .transform(val => val === "true")
        .optional(),
    showSkipWizardButton: z
        .enum(["true", "false"])
        .default("false")
        .transform(val => val === "true")
        .optional(),
    showCloseButton: z
        .enum(["true", "false"])
        .default("false")
        .transform(val => val === "true")
        .optional(),
    showWizardDescription: z
        .enum(["true", "false"])
        .default("false")
        .transform(val => val === "true")
        .optional(),
    loadCustomStyles: z
        .enum(["true", "false"])
        .default("false")
        .transform(val => val === "true")
        .optional(),
});
//# sourceMappingURL=wizard-types-and-schema.js.map